import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import useVisibilitySettings from '@/components/Form/components/VisibilitySettings/hooks/useVisibilitySettings';
import useVisibilitySettingsUsers from '@/components/Form/components/VisibilitySettings/hooks/useVisibilitySettingsUsers';
import LearnerListItem from '@/modules/corporate/modules/assignment/views/AssignmentCreator/components/LearnersAndGroupList/components/ListItem';

import { RestrictedVisibilitySettingsSelectedListProps } from '../../types';

const RestrictedVisibilitySettingsSelectedUsersList: React.FC<
  Omit<RestrictedVisibilitySettingsSelectedListProps, 'contextualGroupsConfig'>
> = (props) => {
  const { t } = useTranslation();
  const { value, onChange, disabled } = props;

  const {
    values,
    methods: { onRemoveUser },
  } = useVisibilitySettings({ value, onChange });

  const { users } = useVisibilitySettingsUsers({ values });

  return (
    <>
      {users.map((user) => (
        <LearnerListItem
          key={user.id}
          disabled={disabled}
          label={{ removeTooltip: t('Group:Modal.RemoveUser') }}
          profilePictureSize={40}
          user={user}
          onRemove={onRemoveUser}
        />
      ))}
    </>
  );
};

export default RestrictedVisibilitySettingsSelectedUsersList;
